import { Box, Typography } from '@mui/material'
import { DataAccordion } from '../../../../../../shared-components/DataAccordion'
import DashboardEmissionsTable from '../../../shared-components/DashboardEmissionsTable'
import { useDispatch, useSelector } from 'react-redux'
import { scopeOneEmissionColumns, scopeOneTitle } from '../../../constants/dashboard-constants'
import { useEffect } from 'react'
import { getGroupEmissionsScopeOne } from '../../../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors'


export default function ScopeOneEmissionsFacilities({ openAccordion, changeAccordion, companyId, groupId, year }) {
    const dispatch = useDispatch()
    const accordionName = 'Scope One Emissions Facility'
    const groups = useSelector(state => state.carbonFootprintBase.groups);
    const { group } = groups.data.find((group) => (group._id === groupId))
    const columns = scopeOneEmissionColumns(group)
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.groupScopeOneLoading))
    const scopeOneEmissionRows = useSelector((state) => (state.emissionFactorsReducer?.groupEmissionsScopeOne?.data))

    useEffect(() => {
        if (openAccordion === accordionName) {
            dispatch(getGroupEmissionsScopeOne(companyId, groupId, year))
        }
    }, [dispatch,
        openAccordion,
        companyId,
        groupId,
        year])

    return (
        <DataAccordion
            title={scopeOneTitle}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 2 }}>
                <Typography variant='h6'>
                    Scope One Emissions for {group} in {year}:
                </Typography>
                <DashboardEmissionsTable loading={isLoading} columns={columns} rows={scopeOneEmissionRows} />
            </Box>
        </DataAccordion>
    )
}
